import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const getClassAndCollectionByProgramId = (ProgramID, locale) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.GROUP_MANAGEMENT.GET_CLASS_AND_COLLECTION_BY_PROGRAM_ID(
      ProgramID,
      locale
    )
  );
};

export default getClassAndCollectionByProgramId;
